import { render, staticRenderFns } from "./ActivityIcon.vue?vue&type=template&id=1ba5c3cf&"
import script from "./ActivityIcon.vue?vue&type=script&lang=js&"
export * from "./ActivityIcon.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports